var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17799 2.80569C9.48236 2.07519 10.5172 2.07519 10.8216 2.80569L12.425 6.65385C12.5544 6.96438 12.8578 7.16667 13.1942 7.16667H17.4107C18.186 7.16667 18.5743 8.10402 18.0261 8.65223L14.6158 12.0625C14.4018 12.2765 14.3207 12.5897 14.4038 12.8807L15.7562 17.6141C15.9846 18.4133 15.0933 19.0639 14.4017 18.6028L10.4621 15.9764C10.1821 15.7898 9.81747 15.7898 9.53755 15.9764L5.60441 18.5985C4.91057 19.061 4.01645 18.4084 4.24554 17.6066L5.59579 12.8807C5.67893 12.5897 5.59777 12.2765 5.38377 12.0625L1.99037 8.66908C1.43594 8.11465 1.82861 7.16667 2.61269 7.16667H6.80536C7.14178 7.16667 7.4452 6.96438 7.57459 6.65385L9.17799 2.80569Z",
    fill: "#FAD43B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStar);
export default __webpack_public_path__ + "static/media/ic_star.adfc6bc260c6d2eddabcfa5036259a84.svg";
export { ForwardRef as ReactComponent };